import { render, staticRenderFns } from "./project-info.vue?vue&type=template&id=cab83106&scoped=true"
import script from "./project-info.vue?vue&type=script&lang=js"
export * from "./project-info.vue?vue&type=script&lang=js"
import style0 from "./project-info.vue?vue&type=style&index=0&id=cab83106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab83106",
  null
  
)

export default component.exports